export default __webpack_public_path__ + "static/media/chinaii.9de95378.jpg";